/** Screen B — entry and payment (`/l/:slug/enter`), §4.2 B. */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const EnterPage = lazyRoute(() => import('./EnterPage'), 'lottery');

export const entryRoutes: RouteObject[] = [{ path: 'enter', element: <EnterPage /> }];
